import { render, staticRenderFns } from "./AllStaff.vue?vue&type=template&id=3a116794&"
import script from "./AllStaff.vue?vue&type=script&lang=js&"
export * from "./AllStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports